import { useWalletsMe } from '@/api/wallets';
import FundedAccount from './FundedAccount';
import { ReactNode, useMemo } from 'react';

export default function FundedAccounts() {
  const { wallet } = useWalletsMe();

  const FindedAccountsMemo: ReactNode[] = useMemo(
    () =>
      wallet?.fundedAccounts?.map(item => (
        <FundedAccount key={item.id.toString()} item={item} />
      )) as ReactNode[],
    [wallet?.fundedAccounts],
  );
  return FindedAccountsMemo;
}
